import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class Vehicule extends PIXI.Sprite {
  constructor(id, index, game) {
    super();

    this.game = game;
    this.id = id;
    this.index = index;

    this.type = ""; // to be set in subclass!
    this.acceleration = this.game.globalAccelerationFactor;

    this.isMoving = false;
    this.taggedForDestroy = false;

    this.targetSpeed = 0;
    this.previousTargetSpeed = 0;
    this.targetSpeedLerp = false;

    this.rightLimit = this.game.appWidth + 300; // can be overwritten in subclass
    this.leftLimit = -300; // can be overwritten in subclass

    this.anchor.set(0, 1);

    this.posYRange = {min: 0, max: 0}; // to override
    this.scalingRange = {min: 1, max: 1}; // to override if you want different scaling based on y position to fake distance

    this.scaling = 1; // this will be overwritten by scaling range above

    this.animationTl = false;
  }

  spawn(startsHidden, side, evenly) {
    side = typeof side !== "undefined" ? side : "left";
    evenly = typeof evenly !== "undefined" ? evenly : false;

    this.texture = PIXI.Texture.from(this.getRandomTexture()); // one of the available car sprites

    let posY = window.randomInRange(this.posYRange.min, this.posYRange.max);
    this.position.y = this.game.appHeight - posY;

    // TODO: set the scale based on the Y position to create a depth effect.
    //  Not 100% sure why it doesn't work as expected, mostly on respawn so let's comment it for now and fix later if needed
    // this.scaling = window.map(posY, this.posYRange.min, this.posYRange.max, this.scalingRange.min, this.scalingRange.max);
    this.scaling = this.scalingRange.min;
    this.scale.set(this.scaling);

    if (startsHidden) {
      if (Object.entries(this.game.vehicules[this.type]).length == 0) {
        this.position.x = this.leftLimit;

      } else {
        if (side === "left") {
          // let's spawn it at the end of the vehicules line
          // if last vehicule is on screen, spawn offscreen on the left

          // Find leftmost vehicule position
          let leftmostVehicule = null;
          for (const [id, vehicule] of Object.entries(this.game.vehicules[this.type])) {
            if (leftmostVehicule === null || vehicule.x < leftmostVehicule.x) {
              leftmostVehicule = vehicule;
            }
          }

          // if leftmost vehicule is on screen, spawn offscreen. Otherwise spawn behind
          if (leftmostVehicule.x > 0) {
            //on screen
            this.position.x = this.leftLimit;
          } else {
            this.position.x = leftmostVehicule.x - leftmostVehicule.width - 20 - this.width; // add the vehicule behind with 20px padding
          }

        } else if (side === "right") {
          // let's spawn it at the start of the vehicules line
          // if first vehicule is on screen, spawn offscreen on the right
          let rightmostVehicule = null;
          for (const [id, vehicule] of Object.entries(this.game.vehicules[this.type])) {
            if (rightmostVehicule === null || vehicule.x > rightmostVehicule.x) {
              rightmostVehicule = vehicule;
            }
          }

          // if rightmost vehicule is on screen, spawn offscreen. Otherwise spawn behind
          if (rightmostVehicule.x < this.game.appWidth) {
            //on screen
            this.position.x = this.rightLimit;
          } else {
            this.position.x = rightmostVehicule.x + rightmostVehicule.width + 20; // add the vehicule in front with 20px padding
          }
        }
      }

    } else {

      if (evenly) {
        if (Object.keys(this.game.vehicules[this.type]).length !== 0) {
          const lastAddedVehiculeID = Object.keys(this.game.vehicules[this.type])[Object.keys(this.game.vehicules[this.type]).length - 1];
          const lastAddedVehicule = this.game.vehicules[this.type][lastAddedVehiculeID];
          this.position.x = lastAddedVehicule.x + lastAddedVehicule.width + 20; // add the vehicule in front with 20px padding
        } else {
          this.position.x = 0;
        }

      } else {
        this.position.x = window.randomInRange(0, this.game.appWidth - this.width);

        if (Object.keys(this.game.vehicules[this.type]).length !== 0) {
          let targetPosX = 0;
          let tries = 1;

          // Now check if we are overlapping another vehicule, try for a maximum of 100 times otherwise it means it's propably impossible to find a non-overlapping position
          while (!targetPosX && tries < 100) {
            targetPosX = this.findNonOverlappingPosition();
            tries++;
          }

          if (targetPosX !== false) {
            this.position.x = targetPosX;
          }
        }
      }

    }

    if (!this.animationTl) {
      this.animationTl = new gsap.timeline({repeat: -1, delay: window.randomInRange(0, 1)});

      this.animationTl.to(this,
        {
          pixi: {
            y: "-=" + this.floatingRange, // here we can use -= because on reset all vehicules are destroyed anyway
          },
          duration: 1,
        }
      );

      this.animationTl.to(this,
        {
          pixi: {
            y: "+=" + this.floatingRange // here we can use += because on reset all vehicules are destroyed anyway
          },
          duration: 1,
        }
      );
    }

    this.isMoving = true;
    this.appear();
  }

  findNonOverlappingPosition() {
    let found = true;
    const randomPosX = window.randomInRange(0, this.game.appWidth - this.width);
    const minPaddingBetween = 0;

    let targetBoundingBox = {
      left: randomPosX - minPaddingBetween,
      right: randomPosX + this.width + minPaddingBetween
    };

    for (const [id, vehicule] of Object.entries(this.game.vehicules[this.type])) {
      let vehiculeBoundingBox = {
        left: vehicule.x,
        right: vehicule.x + vehicule.width
      };

      if (!(vehiculeBoundingBox.left > targetBoundingBox.right || vehiculeBoundingBox.right < targetBoundingBox.left)) {
        found = false;
        break;
      }

    }

    if (found) {
      return randomPosX;
    }

    return false;
  }

  respawn(side) {
    this.spawn(true, side);
  }

  appear() {
    gsap.fromTo(this,
      {
        pixi: {
          alpha: 0,
          scale: 0,
        }
      }, {
        pixi: {
          alpha: 1,
          scale: this.scaling,
        },
        duration: 0.5
      }
    )
  }

  move(backgroundMoving, deltaTime) {
    if (!this.isMoving) {
      return;
    }

    if (backgroundMoving) {
      this.targetSpeed = this.bicycleMovingSpeed;
    } else {
      this.targetSpeed = this.speed;
    }


    if (this.targetSpeed != this.previousTargetSpeed) {

      if (this.targetSpeedLerp !== false) {
        this.targetSpeedLerp.kill();
        this.targetSpeedLerp = false;
      }

      // transition smoothly to target speed
      if (this.targetSpeedLerp !== false) {
        this.targetSpeedLerp.kill();
        this.targetSpeedLerp = false;
      }

      this.targetSpeedLerp = gsap.to(this,
        {
          currentSpeed: this.targetSpeed,
          duration: this.game.globalAccelerationDuration,
          ease: this.game.globalAccelerationEasing,
          overwrite: "auto"
        }
      );

      this.previousTargetSpeed = this.targetSpeed;
    }


    this.position.x += (this.currentSpeed * deltaTime);

    if (this.position.x > this.rightLimit) {
      // Vehicule is way too far right, let's respawn it
      this.respawn("left");
    } else if (this.position.x < this.leftLimit) {
      // Vehicule is way too far left, let's put it up front
      this.respawn("right");
    }
  }

  disable() {
    this.taggedForDestroy = true;

    gsap.to(this,
      {
        pixi: {
          alpha: 0
        },
        onComplete: () => {

          this.emit("disabled", {type: this.type, id: this.id});
        }
      })
  }

  destroy() {
    this.animationTl.kill();
    this.animationTl = null;

    if (this.targetSpeedLerp !== false) {
      this.targetSpeedLerp.kill();
      this.targetSpeedLerp = false;
    }

    this.parent.removeChild(this);
  }
}
